import React, { useState } from "react";
import { motion } from "framer-motion";
import { useQuery } from "react-query";
import { FiExternalLink } from "react-icons/fi";

import { AppWrap, MotionWrap } from "../../wrapper";
import { urlFor, client } from "../../client";

import placeholder from "../../assets/1200.png";
import "./Skills.scss";
import SorryMessage from "../../components/SorryMessage/SorryMessage";

const Skills = () => {
  const [skills, setSkills] = useState([]);
  const [experiences, setExperiences] = useState([]);

  // fetching data using react-query.
  const { status } = useQuery("skills", async () => {
    const query = '*[_type == "experiences"]';
    const skillsQuery = '*[_type == "skills"]';

    const data = await client.fetch(skillsQuery);
    const exp = await client.fetch(query);

    setSkills(data);
    setExperiences(exp);
  });

  // Images lazy loading...
  // document.addEventListener("DOMContentLoaded", function () {
  //   let lazyloadImages;
  //   if ("IntersectionObserver" in window) {
  //     lazyloadImages = document.querySelectorAll(".lazy-load");
  //     let imageObserver = new IntersectionObserver(function (
  //       entries,
  //       observer
  //     ) {
  //       entries.forEach(function (entry) {
  //         if (entry.isIntersecting) {
  //           let image = entry.target;
  //           image.src = image.dataset.src;
  //           image.classList.remove("lazy-load");
  //           imageObserver.unobserve(image);
  //         }
  //       });
  //     });
  //     lazyloadImages.forEach(function (image) {
  //       imageObserver.observe(image);
  //     });
  //   } else {
  //     let lazyloadThrottleTimeout;
  //     lazyloadImages = document.querySelectorAll(".lazy-load");

  //     function lazyload() {
  //       if (lazyloadThrottleTimeout) {
  //         clearTimeout(lazyloadThrottleTimeout);
  //       }
  //       lazyloadThrottleTimeout = setTimeout(function () {
  //         let scrollTop = window.pageYOffset;
  //         lazyloadImages.forEach(function (img) {
  //           if (img.offsetTop < window.innerHeight + scrollTop) {
  //             img.src = img.dataset.src;
  //             img.classList.remove("lazy-load");
  //           }
  //         });
  //         if (lazyloadImages.length === 0) {
  //           document.removeEventListener("scroll", lazyload);
  //           window.removeEventListener("resize", lazyload);
  //           window.removeEventListener("orientationChange", lazyload);
  //         }
  //       }, 20);
  //     }
  //     document.addEventListener("scroll", lazyload);
  //     window.addEventListener("resize", lazyload);
  //     window.addEventListener("orientationChange", lazyload);
  //   }
  // });

  return (
    <motion.div
      whileInView={{ opacity: [0, 1] }}
      transition={{ duration: 0.5 }}
    >
      <h2 className="head-text">
        Here you can find the <span>Skills</span>
        <br />&<span>Technologies</span> used.
      </h2>

      <div className="app__skills-container">
        <div className="app__skills-list">
          {skills.length > 0 && status === "success" ? (
            skills.map((skill) => (
              <div className="app__skills-item app__flex" key={skill._id}>
                <div className="app__flex">
                  <img
                    className=""
                    src={urlFor(skill.icon).format("webp").url() || placeholder}
                    alt={skill.name}
                    loading="lazy"
                  />
                </div>
                <p className="p-text">{skill.name}</p>
              </div>
            ))
          ) : (
            <SorryMessage />
          )}
        </div>

        {/* Experience start */}
        <div className="app__skills-exp">
          {experiences?.map((exp, idx) => (
            <div className="app__skills-exp-item" key={`${exp.year}-${idx}`}>
              <div className="app__skills-exp-year">
                <p className="bold-text">{exp.year}</p>
              </div>

              <div className="app__skills-exp-works">
                {exp?.works?.map((work, idx) => (
                  <div
                    className="app__skills-exp-work"
                    // id={work.name}
                    key={`${work.name}-${idx}`}
                  >
                    <h3 className="bold-text">{work.name}</h3>
                    <p className="p-text">{work.company}</p>
                    <ul className="exp__description">
                      {work.desc.split("-").map((line, index) => (
                        <li key={index}>{line}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Download Resume */}
        <div className="app__skills-exp-resume">
          <div className="app__skills-resume">
            <h3 className="head-text">
              Check <span>Resume</span>
            </h3>
            <div className="app__flex cursor__click">
              <a
                href="https://docs.google.com/document/d/1t2s7Kiq6Uv93RMKSxIDNEWTxBRE7RH03OYTLNMQmB6I/edit?usp=sharing"
                download
                aria-label="Download my Resume"
              >
                <FiExternalLink />
              </a>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default AppWrap(
  MotionWrap(Skills, "app__skills"),
  "skills",
  "app__whitebg"
);
